import Vue from 'vue';
import { clone, cloneDeep, findIndex } from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const FETCHING = 'FETCHING';
export const STOP_FETCHING = 'STOP_FETCHING';
export const SYNC = 'SYNC';
export const SYNC_TEAM_REQUEST_TYPES_BY_CHANNELS = 'SYNC_TEAM_REQUEST_TYPES_BY_CHANNELS';

const data = {
  teams: [],
  fetching: false,
  totalCount: 0,
  pageSizeDefault: undefined,
  teamRequestTypesByChannels: {
    allChannelsOn: true,
    allSkillsOn: true,
    channelsIds: null,
    skillsIds: null,
  },
};

const actions = {
  fetchTeams({ commit }) {
    commit(FETCHING);
    return api.getTeams().then((teams) => {
      commit(SYNC, { teams });
    }).catch((err) => {
      commit(STOP_FETCHING);
      throw err;
    });
  },
  fetchTeamsPagination({ commit }, { page, pageSize, moreData = false }) {
    commit(FETCHING);
    return api.getTeamsPagination(page, pageSize)
      .then(({ teams, totalCount, pageSize: pageSizeDefault }) => {
        commit(SYNC, {
          teams, totalCount, moreData, pageSizeDefault,
        });
      }).catch((err) => {
        commit(STOP_FETCHING);
        throw err;
      });
  },
  createTeam({ commit }, { model }) {
    return api.createTeam(model).then((team) => {
      commit('ADD_TEAM', team);
    });
  },
  updateTeam({ commit }, { id, model }) {
    commit(FETCHING, id);
    return api.updateTeam(id, model).then((team) => {
      commit('UPDATE_TEAM', team);
    }).catch((err) => {
      commit(STOP_FETCHING);
      throw err;
    });
  },
  removeTeam({ commit }, id) {
    commit(FETCHING, id);
    return api.deleteTeam(id).then(() => commit('REMOVE_TEAM', id))
      .catch((err) => {
        commit(STOP_FETCHING);
        throw err;
      });
  },
  fetchTeamMatrixSettings({ commit }, teamId) {
    return api.getTeamMatrixSettings(teamId).then((res) => {
      commit(SYNC_TEAM_REQUEST_TYPES_BY_CHANNELS, res);
    }).catch((err) => {
      throw err;
    });
  },
  updateTeamMatrixSettings({ commit }, {
    teamId, model,
  }) {
    return api.updateTeamMatrixSettings({ teamId, model }).then((res) => {
      commit(SYNC_TEAM_REQUEST_TYPES_BY_CHANNELS, res);
    }).catch((err) => {
      throw err;
    });
  },
};

const mutations = {
  FETCHING(state) {
    state.fetching = true;
  },
  STOP_FETCHING(state) {
    state.fetching = false;
  },
  SYNC(state, {
    teams, totalCount, moreData, pageSizeDefault,
  }) {
    state.pageSizeDefault = pageSizeDefault || state.pageSizeDefault;
    if (moreData) {
      state.teams = state.teams.concat(cloneDeep(teams));
    } else {
      state.teams = cloneDeep(teams);
    }
    mutations.STOP_FETCHING(state);
    state.totalCount = totalCount || state.totalCount;
  },
  ADD_TEAM(state, team) {
    state.teams.push(clone(team));
  },
  UPDATE_TEAM(state, team) {
    const { id } = team;
    const { teams } = state;
    const index = findIndex(teams, { id });
    Vue.set(teams, index, { ...teams[index], ...team });
  },
  REMOVE_TEAM(state, id) {
    const { teams } = state;
    Vue.delete(teams, findIndex(teams, { id }));
    state.totalCount -= 1;
  },
  SYNC_TEAM_REQUEST_TYPES_BY_CHANNELS(state, res) {
    state.teamRequestTypesByChannels = res;
  },
};

const getters = {
  getTeamById(state) {
    const { teams } = state;
    return (id) => (teams[findIndex(teams, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
  getters,
};

export default store;
